import {
  getContent,
  mergeContent,
  newModal,
  mergeModalState,
  closeModal,
  mergeScreenState,
} from "@js/helpers/state.js";

import {
  CE_MODAL_EDIT_SUBJECT_OPEN,
  CE_MODAL_EDIT_SUBJECT_SAVE,
} from "@js/actions/studio/campaign_content_section/modal_edit_subject.js";

let preprocess = (state) => {
  // Trim leading and trailing whitespace off the name.

  let { subject } = state.modal.state;

  return mergeModalState(state, {
    subject: subject.trim(),
  });
};

let validate = (state) => {
  let enteredSubject = state.modal.state.subject;
  let client_content_id = state.modal.state.client_content_id;
  let content = getContent(state, client_content_id);
  // Validate the subject for length.
  if (enteredSubject.length === 0 && content.subject.length > 0) {
    return t("phrases.react_content.subject_cannot_be_blank");
  } else if (enteredSubject.length > 300) {
    return t("phrases.react_content.subject_max_300_characters");
  }

  return null;
};

export default (state = {}, action) => {
  switch (action.type) {
    case CE_MODAL_EDIT_SUBJECT_OPEN: {
      let { client_content_id } = action;
      let content = getContent(state, client_content_id);
      return newModal(state, "edit_subject", {
        client_content_id: client_content_id,
        subject: content.subject,
      });
    }

    case CE_MODAL_EDIT_SUBJECT_SAVE: {
      let preprocessedState = preprocess(state);
      let error = validate(preprocessedState);

      if (error) {
        return mergeModalState(state, {
          validation_error: error,
        });
      }

      let { client_content_id } = preprocessedState.modal.state;

      let updatedState = closeModal(state);

      // Because we can open this modal in a fullscreen editor, we may need to
      // update its state with the new subject
      if (state.screen && state.screen.state) {
        updatedState = mergeScreenState(updatedState, {
          subject: preprocessedState.modal.state.subject,
        });
      }

      return mergeContent(updatedState, client_content_id, {
        subject: preprocessedState.modal.state.subject,
      });
    }

    default:
      return state;
  }
};
